import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  public icons: string[] = ['f017', 'f1ad',
    'f09d', 'f0eb', 'f0f3', 'f51a', 'f793', 'f1b9', 'f6e3'];
  
  constructor(private router: Router) { }

  ngOnInit() {
  }

  public redirectToLogin() {
    const alias = localStorage.getItem('organizationAlias');
    let url = alias + "/login";
    if(alias == null){
      window.location.replace(window.location.origin);
      return;
    }
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/not-found/not-found.component.ts